<script lang="ts" setup>
import {computed, onMounted, ref} from 'vue';
import {useQuizStore} from '@/stores/quizStore';
import QuizSecureTag from "@/components/Quiz/QuizSecureTag.vue";
import HeroFaq from '@/components/Quiz/HeroFaq.vue'


type RegisterType = 'vin' | 'vrm'

const {setVin, setVrm, vin, vrm, resetQuiz, goToNextStep} = useQuizStore()

const register = ref(vin.value || vrm.value || '');
const registerType = ref<RegisterType>(vin.value ? 'vin' : 'vrm');
const showError = ref(false);

const buttonLabel = computed(() => registerType.value === 'vrm' ? 'VIN' : 'VRM');
const isValid = computed(() => register.value.length)

const toggleRegisterType = () => {
  registerType.value = registerType.value === 'vrm' ? 'vin' : 'vrm';
  register.value = '';
}

const handleSubmit = () => {
  if (!isValid.value) {
    showError.value = true;
    return;
  }

  if (registerType.value === 'vrm') {
    setVrm(register.value)
    setVin('')
  } else {
    setVin(register.value)
    setVrm('')
  }

  goToNextStep()
}


function handleSearchByAddress() {
  resetQuiz()
    .then(() => {
      goToNextStep()
    })
}

onMounted(() => {
  resetQuiz(false)
})
</script>

<template>
  <div class="pt-10 px-4 text-center">
    <h1 class="font-medium text-(--brand-primary) mb-5 text-4xl lg:text-6xl max-w-[25ch] mx-auto">
      Find out if you qualify for a claim in <strong>seconds</strong></h1>
    <p class="mb-5 text-xl">Enter your REG for a <i class="font-bold">quick</i> eligibility check.
    </p>

    <div class="max-w-lg mx-auto pt-10">
      <form @submit.prevent="handleSubmit"
            class="bg-white flex px-4 py-2.5 rounded-lg border border-(--brand-neutral) transition-all mb-6 md:mb-10"
            :class="showError ? 'border-red-500': 'hover:border-(--brand-primary)'">
        <input type="text" placeholder="Enter Your REG"
               class="grow py-2 px-4 focus:outline-none text-xl placeholder:text-[#757582] placeholder:font-medium w-full uppercase"
               v-model="register" @input="showError = false">
        <button
          class="border border-(--brand-quaternary) text-gray-800 px-4 py-2 rounded-lg hover:bg-[#d8bd36] text-base whitespace-nowrap cursor-pointer transition"
          :class="{'bg-[#FFDE02]/60': showError,  'bg-(--brand-quaternary)': !showError}"
        >Get started
        </button>
      </form>

      <p class="text-gray-600 text-center font-medium">Don’t have a REG number?</p>

      <div class="flex items-center justify-center space-x-2">
        <p class="text-gray-600 font-medium text-xs sm:text-base">SEARCH BY:</p>
        <button @click="toggleRegisterType"
                class="border border-gray-300 rounded-xl px-6 py-1 text-gray-600 bg-white hover:bg-gray-50 focus:outline-none font-medium transition">
          {{ buttonLabel }}
        </button>
        <button @click="handleSearchByAddress"
                class="border border-gray-300 rounded-xl px-4 py-1 text-gray-600 bg-white hover:bg-gray-50 focus:outline-none font-medium transition">
          ADDRESS
        </button>
      </div>

    </div>

    <HeroFaq class="mt-10 md:mt-16" />

    <div class="max-w-lg mx-auto pt-10">
      <QuizSecureTag />
    </div>
  </div>
</template>
